import { Button } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import downloadIcon from '../../../../assets/document-download.png'
import CustomTable from '../../../../components/Table/CustomTable'
import { AuditColumn, AuditData } from '../../../../types/TablesTypes/AuditTrails'
import client from '../../../../api/client'
import moment from 'moment'
const AuditTrail = () => {
    const [auditTrails, setAuditTrails] = useState<any>()
    const [tableRow, setTableRow] = useState<any[]>([])
    useEffect(() => {
        const fetchData = async () => {
            await getAuditTrails()
        }
        fetchData()
    }, [])

    const getAuditTrails = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/audit/trails');

            setAuditTrails(response.data);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    }

    const dataTransaction = () => {
		const tempArr: AuditData[] = [];
		auditTrails?.items
			?.slice(0)
			.reverse()
			.forEach((audit: AuditData, index: number) => {
				tempArr.push({
					name: audit?.name,
					role: audit?.role,
					emailAddress: audit?.emailAddress,
					action: audit?.action,
					ipAddress: audit?.ipAddress || 'N / A',
					activityType: audit?.activityType,
					dateCreated: moment(audit?.dateCreated).format(
						'MMMM Do YYYY, h:mm a'
					),
				});
			});
		return tempArr;
	};

	useEffect(() => {
		setTableRow(dataTransaction());
	}, [auditTrails?.items]);
    return (
        <div>
            <div className='flex'>
                <Button className='ml-auto rounded-sm bg-black'>
                    <div className='flex gap-2'>
                        <img src={downloadIcon} alt="Download" />
                        <span>Export</span>
                    </div>
                </Button>
            </div>
            <div className='my-8'>
                <CustomTable headings={AuditColumn} data={tableRow ? tableRow :[]} emptyMessage='You do not have any udit trails'/>
            </div>
        </div>
    )
}

export default AuditTrail
